import { useEffect } from "react";
var handleUnsavedChanges = function (form, dirtyCheck) {
    // console.log('handleUnsavedChanges called...', form, dirtyCheck)
    if (dirtyCheck === void 0) { dirtyCheck = null; }
    var checkIsDirty = dirtyCheck ? dirtyCheck : function () {
        return form.isDirty;
    };
    function handleUnsaved(event) {
        // console.log('handleUnsaved called...', event);
        if (event.detail.visit.method !== 'get') {
            return;
        }
        if (checkIsDirty()) {
            console.log("Form is dirty", form.data, event);
            console.log('form.data', form.data);
            console.log('form.defaults', form.defaults);
            // console.log('form.data.client === form.defaults.client', form.data.client === form.defaults.client);
            var result = confirm("You have unsaved changes, are you sure that you want to leave without saving?");
            if (!result) {
                event.preventDefault();
            }
        }
    }
    useEffect(function () {
        // console.log('> inertia:before handleUnsaved bound')
        document.addEventListener('inertia:before', handleUnsaved);
        return function () {
            // console.log('< inertia:before handleUnsaved removed')
            document.removeEventListener('inertia:before', handleUnsaved);
        };
    });
};
export function useUnsavedChanges(form, dirtyCheck) {
    if (dirtyCheck === void 0) { dirtyCheck = null; }
    var checkIsDirty = dirtyCheck ? dirtyCheck : function () {
        return form.isDirty;
    };
    function handleUnsaved(event) {
        if (event.detail.visit.method !== 'get') {
            return;
        }
        if (checkIsDirty(form.isDirty)) {
            console.log("Form is dirty", form.data, event);
            console.log('form.data', form.data);
            console.log('form.defaults', form.defaults);
            // console.log('form.data.client === form.defaults.client', form.data.client === form.defaults.client);
            var result = confirm("You have unsaved changes, are you sure that you want to leave without saving?");
            if (!result) {
                event.preventDefault();
            }
        }
    }
    return [
        function () { return document.addEventListener('inertia:before', handleUnsaved); },
        function () { return document.removeEventListener('inertia:before', handleUnsaved); }
    ];
}
export default handleUnsavedChanges;
